module.exports = __webpack_public_path__ + "static/media/goal5.3639cf50.svg";